export enum CmServiceFilterType {
  cmSearch = 'cmSearch',
  cmSubcategories = 'cmSubcategories',
  cmTypeTreatments = 'cmTypeTreatments',
  cmRegions = 'cmRegions',
  cmCounties = 'cmCounties',
  cmAges = 'cmAges',
  cmLanguages = 'cmLanguages',
  cmDisorders = 'cmDisorders',
  cmEthnicities = 'cmEthnicities',
  cmInsurances = 'cmInsurances',
  cmFavorites = 'cmFavorites',
  cmOrganizations = 'cmOrganizations',
}
